// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__34GBI","cardContainer":"styles_cardContainer__36ppj"};